// IDR currency formatting and date helpers
// All timestamps display in Asia/Jakarta (WIB) timezone regardless of viewer locale.
const TZ = "Asia/Jakarta";

export function formatIDR(n) {
  const num = Number(n || 0);
  return "Rp " + num.toLocaleString("id-ID", { maximumFractionDigits: 0 });
}

// Quantity / material formatting — uses Indonesian convention "1.000,85"
// Allows up to 2 decimal places (does not pad zeros for whole numbers).
export function formatQty(n) {
  const num = Number(n || 0);
  return num.toLocaleString("id-ID", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export function formatNumber(n, digits = 0) {
  const num = Number(n || 0);
  return num.toLocaleString("id-ID", { maximumFractionDigits: digits });
}

// Parse a price string that may include comma decimal (e.g. "12.500,50" -> 12500.5).
// Use this for unit prices that may have 2 decimal places.
export function parsePrice(str) {
  if (typeof str === "number") return str;
  if (str === null || str === undefined || str === "") return 0;
  const s = String(str).trim();
  // If the string contains a comma, treat Indonesian: dot=thousand, comma=decimal.
  if (s.includes(",")) {
    const normalized = s.replace(/\./g, "").replace(",", ".");
    const n = Number(normalized);
    return Number.isFinite(n) ? n : 0;
  }
  // Otherwise legacy: strip non-digits (preserve old behaviour for plain numbers)
  const cleaned = s.replace(/[^\d]/g, "");
  return Number(cleaned) || 0;
}

export function parseIDR(str) {
  if (typeof str === "number") return str;
  if (!str) return 0;
  const cleaned = String(str).replace(/[^\d]/g, "");
  return Number(cleaned) || 0;
}

// Parse a qty string in Indonesian format ("1.000,85" -> 1000.85). Accepts plain numbers too.
export function parseQty(str) {
  if (typeof str === "number") return str;
  if (str === null || str === undefined || str === "") return 0;
  const s = String(str).trim();
  // Indonesian: dot = thousand separator, comma = decimal
  const normalized = s.replace(/\./g, "").replace(",", ".");
  const n = Number(normalized);
  return Number.isFinite(n) ? n : 0;
}

export function formatDate(iso) {
  if (!iso) return "-";
  // Date-only strings: parse manually to avoid UTC->local timezone shifts that can flip the day.
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  }
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric", timeZone: TZ });
  } catch (e) {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false, timeZone: TZ }) + " WIB";
  } catch (e) {
    return iso;
  }
}

export function formatTime(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false, timeZone: TZ });
  } catch (e) {
    return iso;
  }
}

export function todayISO() {
  // Local-date YYYY-MM-DD (no UTC shift)
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
